import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';

import 'typeface-roboto';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import './index.css';
import './services/firebase';
import App from './App';

const root = createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <StyledEngineProvider injectFirst>
    <App />
  </StyledEngineProvider>
  // </React.StrictMode>
);
